module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAQBAMAAACB27BXAAAAHlBMVEX1MzMAAAD2MTH2MTHzMTHvLy/1MTH1MTH/Kir1MTHr6ftWAAAACXRSTlMZAMaMUw/wfgZ/czZJAAAAmUlEQVQY01XQoQ7CMBCA4T+9LayyYn4JM7gG9gDNHK44JHaO4OYweFISSN+WdYRl/eWXE3eHMQ/P0tkYTM260yQ+k9JQwy0b4g5jA/KXCg/DExRzLSWgYriiekt/kGCTjDEGdLeXtnctqWEWtNiiWeSNQisn9ie7GD9JitfRbV0J6BgvFAjSIa4CNkPINkzlV6TyS302MX3jC+t6GnyuVIvcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/Header/hot.png
// module id = Tmzj
// module chunks = 41